import React,{useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { AuthData } from '../../Services/Authdata';
import {changeAdminPassword} from '../../Services/AdminLogin';
import validate from './changePasswordValidation';
import useForm from './useForm';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import {Redirect} from 'react-router-dom';


export default function ChangePassword(props){

  const [loader, setLoader] = useState("");
  const [action, setAction] = useState(false);
    const initialValues = {
		old_password: '',
    new_password: '',
    confirm_password:'',
  }
	const { values, errors, handleChange, handleSubmit } = useForm(
		initialValues,
		login,
		validate,
	)
  const sendData = (message) => {
    props.parentCallback(message);
  }
	function login() {
    
    setAction(true);
    
    setLoader(<CircularProgress color="secondary" style={{"position":"absolute",marginLeft:"50%",marginTop:'8%'}}/>)
    setTimeout(function(){
      setLoader("");
      changeAdminPassword('admin/changePassword/'+AuthData().id,'POST',AuthData().token,values)
      .then((result)=>{
        if(result.status === 1){
          sendData(<Alert variant="outlined" severity="success" style={{marginLeft:"2%",marginRight:"2%"}}> {result.message}</Alert>);
          setTimeout(function(){
            return <Redirect to={'/'} />
          },200)
        }else{
          setAction(false);
          sendData(<Alert variant="outlined" severity="error" style={{marginLeft:"2%",marginRight:"2%"}}>{result.message}</Alert>)
        }
      });
    },200)
    
	}
return (
    <div>
      {/* {loginMessage} */}
      {loader}
        {/* <form onSubmit={submitHandle}> */}

        <form onSubmit={handleSubmit} noValidate>
                <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                    <TextField 
                    id="outlined-basic1"
                    error={errors.old_password?true:false}
                    helperText={errors.old_password}
                    label="Old Password"
                    variant="outlined"
                    type="password"
                    name='old_password' 
                    required
                    size="small"
                    onChange={handleChange}
                  //   onChange={e => setOpassword(e.target.value)}
                    />
                </FormControl>

                <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                    <TextField 
                    error={errors.new_password?true:false}
                    helperText={errors.new_password}
                    id="outlined-basic2"
                    label="New Password"
                    variant="outlined"
                    type="password"
                    name='new_password' 
                    size="small"
                    required
                    onChange={handleChange}
                  //   onChange={e =>setNpassword(e.target.value)}
                    />
                </FormControl>
                <FormControl style={{width:'100%',marginTop:"5px",marginBottom:"5px"}}>
                    <TextField 
                  error={errors.confirm_password?true:false}
                  helperText={errors.confirm_password}
                    id="outlined-basic3"
                    label="Confirm Password"
                    variant="outlined"
                    type="password"
                    name='confirm_password' 
                    size="small"
                    required
                    onChange={handleChange}
                  //   onChange={e =>setCpassword(e.target.value)}
                    />
                </FormControl>
                <FormControl style={{marginBottom:"5px"}}>
                  <Button type="submit" disabled={action} variant="contained" color="primary" disableElevation>
                    Update
                  </Button>
                </FormControl>
              </form>
    </div>
)
}


// WEBPACK FOOTER //
// ./src/Pages/Auth/ChangePassword.js